import loadable from '@loadable/component';
import { ChallengeTemplatePackTypes, type TChallengeTemplatePack } from '../../../api/graphql-typings';
import FullPageLoading from '../../../components/Loading/FullPageLoading';
import { getPath } from '../../../utils/routing-utils.js';
import { THERAPIST_ROUTES_PREFIX } from '../../therapist-planning/therapist-planning.path';

export const T_CHALLENGE_PACK_PATH = `${THERAPIST_ROUTES_PREFIX}/challenge-packs/:packId`;
export const T_SERIAL_CHALLENGE_PACK_PATH = `${THERAPIST_ROUTES_PREFIX}/serial-challenge-packs/:packId`;

export const ChallengePackLazy = loadable(async () => import('./challenge-pack.view'), {
  fallback: <FullPageLoading />,
});

export function getChallengePackPath(pack: Pick<TChallengeTemplatePack, 'id' | 'type'>) {
  return getPath(pack.type === ChallengeTemplatePackTypes.Serial
    ? T_SERIAL_CHALLENGE_PACK_PATH : T_CHALLENGE_PACK_PATH, { packId: pack.id });
}
